import Marquee from "react-fast-marquee";

const ITEMS = [
  "JCB EXCAVATION",
  "TAXI PERMIT",
  "OUTSTATION TOURS",
  "ROAD LEVELING",
  "PLOT CLEANING",
  "AIRPORT PICKUP",
  "WEDDING BOOKING",
];

export const MarqueeStrip = () => {
  return (
    <div className="relative border-y border-white/10 bg-asphalt py-8 md:py-12 overflow-hidden" data-testid="marquee">
      <Marquee speed={45} gradient={false} autoFill>
        {ITEMS.map((t, i) => (
          <span key={i} className="flex items-center">
            <span className="font-khand font-700 uppercase text-6xl md:text-8xl text-outline mx-8">{t}</span>
            <span className="h-3 w-3 rounded-full bg-jcb mx-8" />
          </span>
        ))}
      </Marquee>
    </div>
  );
};
